import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import style from './MovePoses.module.sass';

const PoseCard = ({ pose, index, isSelected, onSelect }) => {
  return (
    <Draggable draggableId={pose.id.toString()} index={index}>
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          className={`${style.poseCard} ${snapshot.isDragging ? style.dragging : ''} ${isSelected ? style.selected : ''}`}
          onClick={() => onSelect(pose.id)}
        >
          {pose.imageUrl ? (
            <img src={pose.imageUrl} alt={pose.url} className={style.poseImage} />
          ) : (
            <div className={style.noImage}>No image</div>
          )}
          <div className={style.poseUrl}>{pose.url}</div>
          {isSelected && <div className={style.bestBadge}>Best Pose</div>}
        </div>
      )}
    </Draggable>
  );
};

export default PoseCard;
